import React from 'react';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import TextInput, { TextInputProps } from '../TextInput';

const SearchInput: React.FC<TextInputProps> = ({ textFieldProps, ...props }: TextInputProps) => (
  <TextInput
    showLabel={false}
    textFieldProps={{
      ...textFieldProps,
      InputProps: {
        ...(textFieldProps && textFieldProps.InputProps),
        startAdornment: (
          <InputAdornment position="end">
            <SearchIcon color="primary" />
          </InputAdornment>
        ),
      },
      fullWidth: true,
    }}
    {...props}
  />
);

SearchInput.displayName = 'SearchInput';
export default SearchInput;
